export const name = 'bell';

export const Bell = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.3326 16.1399V10.8074C5.3326 9.93118 5.50531 9.06355 5.84085 8.25412C6.17639 7.44469 6.66819 6.70934 7.28811 6.09011C7.90804 5.47087 8.64395 4.97991 9.45375 4.64528C10.2636 4.31065 11.1314 4.13891 12.0076 4.1399C13.7759 4.1399 15.4718 4.84236 16.7222 6.09276C17.9726 7.34316 18.6751 9.03907 18.6751 10.8074V16.1399L21.3376 18.8024H2.6626L5.3326 16.1399Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M15.3 18.8025C15.3 19.6764 14.9534 20.5146 14.3361 21.1333C13.7189 21.7519 12.8814 22.1005 12.0075 22.1025C11.1323 22.1025 10.2929 21.7548 9.67407 21.1359C9.0552 20.5171 8.70752 19.6777 8.70752 18.8025"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M12 1.89746V4.13996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
